import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Modal.scss';

class Modal extends Component {
    static propTypes = {
      /** Title */
      title: PropTypes.string,
      /** custom class for general popup */
      customizedClassName: PropTypes.string,
      /** content for general popup */
      children: PropTypes.node,
      /** close popup function */
      closePopup: PropTypes.func,
      /** isPopupShowing */
      isPopupShowing: PropTypes.bool,
    }

    static defaultProps = {
      title: 'Title',
      customizedClassName: '',
      children: <></>,
      isPopupShowing: false,
      closePopup: () => {
      },
    }

    render() {
      const {
        isPopupShowing, customizedClassName, children, closePopup, title,
      } = this.props;
      return (isPopupShowing ? (
        <div className="modal">
          <div className={`modal__content ${customizedClassName}`}>
            <div className="modal__header">
              <h5>{title}</h5>
              <div className="modal__header__dbf-close-icon" onClick={closePopup} />
            </div>
            {children}
          </div>
        </div>
      ) : '');
    }
}

export default Modal;
